var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 536,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 114,
    width: 330,
    height: 536
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 114,
    width: 330,
    height: 536
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-302 -114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573 258C573 326.483 517.483 382 449 382 380.517 382 325 326.483 325 258 325 189.517 380.517 134 449 134 517.483 134 573 189.517 573 258Z",
    fill: "#F4F7F9",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 650C581.504 650 573 641.431 573 630.854L573 267.146C573 256.57 581.504 248 592 248 602.496 248 611 256.57 611 267.146L611 630.872C610.982 641.431 602.496 650 592 650Z",
    fill: "#292F33",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.894 229.404C590.922 229.404 590.004 229.62 589.05 229.692 575.874 164.36 518.076 115 448.938 115 370.116 115 306 179.144 306 258 306 336.856 370.116 401 448.938 401 511.362 401 564.426 360.699 583.866 304.784 586.458 305.343 589.122 305.667 591.876 305.667 612.936 305.667 630 288.595 630 267.526 630 246.475 612.936 229.404 591.894 229.404ZM448.938 362.878C391.14 362.878 344.124 315.841 344.124 258 344.124 200.159 391.158 153.123 448.938 153.123 506.736 153.123 553.77 200.159 553.77 258 553.77 315.841 506.736 362.878 448.938 362.878Z",
    fill: "#67757F",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.098 169.949C489.655 159.257 470.076 153 449 153 391.019 153 344 200.005 344 258.009 344 279.087 350.274 298.668 360.947 315.111L506.098 169.949ZM404.199 352.849C417.81 359.286 432.955 363 449 363 506.981 363 554 315.995 554 257.991 554 241.944 550.287 226.78 543.85 213.185L404.199 352.849Z",
    fill: "#BDDDF4",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory13);
export default __webpack_public_path__ + "static/media/accessory13.36cdf863ca049a1ceef31ddbde2ae88b.svg";
export { ForwardRef as ReactComponent };